<template>
  <div id="exam-wrapper">
    <b-container style="max-width:1144px">
      <template v-if="step == 0">
        <div class="card exam-card">
          <div class="card-body">
            <b-row>
              <b-col style="max-width: 568px;" >
                <!-- <p>{{$t('planesYPrecios.paso-3.preselección.texto-recomendacion')}}</p> -->
                <h1 class="text-center mb-4">{{$t('public-exam.kickoff.title')}}</h1>
                <div class="exam-indications">
                  <h6 class="bold">{{$t('public-exam.kickoff.subtitle')}}</h6>
                  <ul>
                    <li>{{$t('public-exam.kickoff.instruction1')}}</li>
                    <li>{{$t('public-exam.kickoff.instruction2')}}</li>
                  </ul>
                </div>
                <div class="text-center mt-4">
                  <img class="img-first d-lg-none mb-4" src="@/assets/img/exam-1.png" />
                  <b-button variant="primary" :disabled="!carga_evaluacion_flag"  @click="goToExam()">{{$t('public-exam.kickoff.btnStartExam')}}</b-button>
                </div>
              </b-col>
              <b-col class="ml-auto" md="4">
                <img class="img-first d-none d-lg-block" src="@/assets/img/exam-1.png" />
              </b-col>
            </b-row>
          </div>
        </div>
      </template>
      <template v-if="step == 1">
        <EvaluacionPreguntas v-if="showEvaluation" 
            :evaluation="evaluation"  
            :questions="questions"   
            @listenChild="evaluationValueChild" 
        >

        </EvaluacionPreguntas>
      </template>
      <template v-if="step == 2 & flag_form">
        <div class="card exam-card">
          <div class="card-body pb-5">
            <b-row class="exam-form-end">
              <b-col md="4 text-center">
                <img class="img-second" src="@/assets/img/exam-2.png" />
              </b-col>
              <b-col md="7" class="m-auto">
                <h1 class="text-center mb-4">{{$t('public-exam.contact-form.title')}}</h1>
                <h6 class="sub-title">{{$t('public-exam.contact-form.subtitle')}}</h6>
                <div class="d-md-flex" style="gap:1rem">
                  <b-form-group class="flex-fill">
                    <b-form-input :placeholder="$t('public-exam.contact-form.lblName')" v-model="formStudent.firstName" required
                      v-bind:class="{ error: $v.formStudent.firstName.$error}" @blur="$v.formStudent.firstName.$touch()">
                    </b-form-input>
                    <span class="error-input">{{ validationMsgRegistro($v.formStudent.firstName)}}</span>
                  </b-form-group>
                  <b-form-group class="flex-fill">
                    <b-form-input :placeholder="$t('public-exam.contact-form.lblLastname')" v-model="formStudent.lastName" required
                      v-bind:class="{ error: $v.formStudent.lastName.$error}" @blur="$v.formStudent.lastName.$touch()">
                    </b-form-input>
                    <span class="error-input">{{ validationMsgRegistro($v.formStudent.lastName)}}</span>
                  </b-form-group>
                </div>
                <b-form-group>
                  <div class="d-flex flex-column">
                    <div class="d-flex">
                      
                      <input  id="input-telefono" type="tel"  v-model="formStudent.phoneNumber" 
                          class="form-control-phone" :placeholder="$t('public-exam.contact-form.lblPhone')"
                          required v-bind:class="{ error: $v.formStudent.phoneNumber.$error}" @blur="$v.formStudent.phoneNumber.$touch()" >
               
                    </div>
                    <span class="error-input mt-1" >{{ validationMsgRegistro($v.formStudent.phoneNumber)}}</span>

                </div>
                </b-form-group>
                <b-form-group>
                  <b-form-input :placeholder="$t('public-exam.contact-form.lblEmail')" type="email" v-model="formStudent.email" required
                      v-bind:class="{ error: $v.formStudent.email.$error}" @blur="$v.formStudent.email.$touch()" >
                  </b-form-input>
                  <span class="error-input">{{ validationMsgRegistro($v.formStudent.email)}}</span>
                </b-form-group>
                <b-form-group class="mb-4">

                  <b-form-checkbox name="flagAcepted" id="flagAcepted"  
                      v-model="formStudent.flagAcepted"  
                      v-bind:class="{ error: $v.formStudent.flagAcepted.$error}"  
                      @change="$v.formStudent.flagAcepted.$touch()" 
                      @blur="$v.formStudent.flagAcepted.$touch()" 
                      >
                 
                      <span v-html="$t('public-exam.contact-form.lblAccepTerms')" style="color: #939393;">
                      </span>
                      <span class="error-input d-block">{{ validationMsgRegistro($v.formStudent.flagAcepted)}}</span>
                        
                  </b-form-checkbox>

                  
              </b-form-group>
                <div class="text-center mt-4 mt-md-5">
                  <!-- :disabled="$v.formStudent.$invalid" -->
                  <b-button variant="primary" @click="saveEvaluation()"
                    :class="{ loading: isLoading }"
                    >
                    {{ $t('public-exam.contact-form.btnSend') }}
                  </b-button>
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </template>

      <template v-else-if="step == 3 & flag_resultados" >
        <div class="card exam-card card_evaluation_result">
          <div class="card-body">
            <img class="img-result d-none d-md-block" src="@/assets/img/result.png" />
            <h1 class="text-center mb-4">
              {{$t('public-exam.contact-form.examResult')}}
            </h1>
            <div class="quiz-status">
              <p v-if="evaluationData.duration"><icon name="time" />{{$t('planesYPrecios.paso-3.resultado.tiempo')}}: <b>{{evaluationData.duration}} {{$t('planesYPrecios.paso-3.resultado.minutos')}}</b></p>
              <p v-if="evaluationData.answersCorrect"><icon name="circle-check" />{{$t('planesYPrecios.paso-3.resultado.respuestas')}}: <b>{{evaluationData.answersCorrect}}</b></p>
            </div>
            <div class="box-content">
              <b-row>
                <b-col class="text-center d-flex flex-column justify-content-center">
                  <h4>
                    {{$t('planesYPrecios.paso-3.resultado.info.nivel')}}
                    <span>{{$t('planesYPrecios.paso-3.resultado.info.nivel-2')}}</span>
                  </h4>
                  <div class="level-box" :id="'level_'+ evaluationData.level.id" :class="'gd-'+evaluationData.level.id"> 
                    <h1>{{evaluationData.level.abbreviation}}</h1>
                    <span>{{evaluationData.level.name}}</span>
                  </div>
                  
                </b-col>
                <b-col md="7" class="border-c py-4">
                  <div class="content-scroll">
                    <ul>
                      <li v-for="feat in evaluationData.level.features" :key="feat.id" :id="'levelFeature_'+feat.id">
                        <h6  v-show="false">{{feat.title}}</h6>
                        <div class="box">
                        <div class="content" v-for="detail in feat.featureDetails" :key="detail.id" :id="'levelFeatureDetail_'+detail.id">
                          <h6>{{detail.title}}</h6>
                          <p>{{detail.description}}</p>
                        </div>
                        </div>
                      </li>
                    </ul>
                  </div>
                </b-col>
              </b-row>
            </div>
          </div>
        </div>
        
      </template>
    </b-container>
  </div>
</template>
<script>
import 'intl-tel-input/build/css/intlTelInput.css';
import intlTelInput from 'intl-tel-input';
import { baseInstanceAxios } from '@/assets/js/axiosBase.js';
import EvaluacionPreguntas from '@/views/compra/evaluacion-preguntas'; 
import { required, email, numeric, sameAs, minLength, maxLength} from 'vuelidate/lib/validators';
import { validationMessage } from 'vuelidate-messages';

const formRegisterMessages = {
    required:  function () {
        return this.$t('validations.formRegisterMessages.required')
    },
    email:  function () {
        return this.$t('validations.formRegisterMessages.email')
    },
    flagEmailEnUso:  function () {
        return this.$t('validations.formRegisterMessages.flagEmailEnUso')
    },
    minLength: function ({ $params }){
        return this.$t('validations.formRegisterMessages.minLength', {nro: $params.minLength.min}) ;
    },
    maxLength: function({ $params }) {
        return this.$t('validations.formRegisterMessages.maxLength', {nro: $params.maxLength.max}) ;
    },
    alphaWithSpaces: function () {
        return this.$t('validations.formRegisterMessages.alphaWithSpaces')
    },
    numeric:  function () {
        return this.$t('validations.formRegisterMessages.numeric')
    },
    requiredTyC:  function () {
        return this.$t('validations.formPublicExam.accepTerms')
    },
    sameAs:  function () {
        return this.$t('validations.formPublicExam.accepTerms')
    },
    validPhone:function (){
        return this.$t('validations.formPublicExam.invalidNumber')
    },
};

const errorMap = ["Invalid number", "Invalid country code", "Too short", "Too long", "Invalid number"];

export default {
  name: "AppExam",
  components:{
    EvaluacionPreguntas
  },
  props: {
			receivedValue: null
  },
  data() {
    return {
      step: 0,
      iti: null,
      lang: 'es',
			API_URL: process.env.VUE_APP_API_URL,
      personAgeAdult : 20,
      showEvaluation:false,
      flag_form:false,
      flag_resultados:false, 
      isLoading: false,
      questions: [],
      evaluation: {
        id:0,
        name:'',
        duration:0 ,
        durationEvaluationDate:"0001-01-01 00:00:00"
      },
      carga_evaluacion_flag: false,
      carga_evaluacion_mje : this.$t('planesYPrecios.paso-3.preselección.button-loading'),
      evaluationData:{},
      formStudent: {
        flagAcepted:false
      },
    }
  },
 
  validations: {
      formStudent: {
          firstName: {
              required,
              minLength: minLength(2),
              maxLength: maxLength(50),
              alphaWithSpaces(value) {
                  return /^[A-zÀ-ú\s]*$/.test(value);
              }
          },
          lastName: {
              required,
              minLength: minLength(2),
              maxLength: maxLength(60),
              alphaWithSpaces(value) {
                  return /^[A-zÀ-ú\s]*$/.test(value);
              }
          },
          email: {
              required,
              email,
          },
          flagAcepted: {
              requiredTyC(value){
                  return value;
              }
          },
          phoneNumber: {
              required,
              numeric,
              validPhone(value) {
                
                if(this.iti  != null){
                   
                    var formattedNumber = this.iti.getNumber()
                    //console.log("formattedNumber: " + formattedNumber)
                    var valid = this.iti.isValidNumber()
                    //console.log("valid: " + valid)
                    return valid
                 
                }
                return false;
              },
          },
          
      }
    },
  mounted(){
    
  },
  async created() {
    
    this.lang = this.$route.params.lang == undefined ?  this.lang : this.$route.params.lang;
  
    localStorage.setItem('lang', this.lang);
    this.$i18n.locale =  this.lang;
	 
    this.getEvaluation();
    this.getQuestions();
  },
  methods: {
    validationMsgRegistro: validationMessage(formRegisterMessages),
    getEvaluation:function(){
        
        baseInstanceAxios
        .get(this.API_URL + `/Resources/Evaluations/GetByAge?personAge=` + this.personAgeAdult)
        .then(response => {
          if(response.data != null && response.data.entity != null){
            this.duration = response.data.entity.duration;

              let durationEvaluationDate  = new Date("0001-01-01 00:00:00");
              durationEvaluationDate.setMinutes( durationEvaluationDate.getMinutes() + (response.data.entity.duration));
              
              this.evaluation = {
                id:response.data.entity.id,
                name:response.data.entity.name,
                duration:response.data.entity.duration,
                durationEvaluationDate: durationEvaluationDate
              };
          }
        });
    },
    getQuestions: function() {
      let flag = this.lang == 'en' ? true : false;
      baseInstanceAxios
        .get(this.API_URL + `/Resources/EvaluationsQuestions/ExamQuestions?flagLanguage=${flag}` )
        .then(response => {

          if(response.data != null && response.data.value == 1){  //AUN NO DIO EVALUACIÓN DE NIVEL
            if(response.data.list != null){
              //this.initEvents();
              this.questions = response.data.list;

              this.carga_evaluacion_mje =  this.$t('planesYPrecios.paso-3.preselección.button'),
              this.carga_evaluacion_flag = true;
              
            }
          }
        });
		}, 
		setIntlTelInput() {
      
      this.$nextTick(function() {

        const inputElement = document.querySelector("#input-telefono");

        this.iti = intlTelInput(inputElement, {
          utilsScript: "https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.13/js/utils.min.js",
          preferredCountries: ['PE', 'US'], 
          separateDialCode: true ,
          initialCountry: "auto",
          geoIpLookup: callback => {
            fetch("https://ipapi.co/json")
              .then(res => res.json())
              .then(data => callback(data.country_code))
              .catch(() => callback("us"));
          }
        }); 
   
      
      })
    },    
     
    evaluationValueChild(data) {
      var questionAnswerSelected = data.listAnswersSelecteds;
      var evaluation = data.evaluation;
      var timeDuration = data.timeDuration;
      var duration = data.duration;
       
      this.evaluationData = {
        duration: duration,
        timeDuration: timeDuration,
        age: this.personAgeAdult, 
        evaluationId: evaluation.id,
        codigoUnico: this.generateUniqueId(),
        userCreated: this.generateUniqueId(),
        questionAnswerSelected: questionAnswerSelected
      }

      this.flag_form = true;
      this.step = 2; 
      this.setIntlTelInput();
      
    },
    generateUniqueId(){
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'
        .replace(/[xy]/g, function (c) { 
            const r = Math.random() * 16 | 0,  
                v = c == 'x' ? r : (r & 0x3 | 0x8); 
            return v.toString(16); 
        });
    },
    goToExam(){
      this.showEvaluation = true;
      this.step = 1;
      
    },
    
    saveEvaluation(){
     
      if (!this.isLoading) { 
        this.$v.$touch();
        if (this.$v.$invalid) {
            return;
        }
        this.isLoading = true;

       
        this.evaluationData.guestFirstName =  this.formStudent.firstName;
        this.evaluationData.guestLastName = this.formStudent.lastName;
        this.evaluationData.guestPhoneNumber = "+" + this.iti.selectedCountryData.dialCode + "" +this.formStudent.phoneNumber;
        this.evaluationData.guestEmail = this.formStudent.email;

        let flagLanguage = this.lang == "en";

        baseInstanceAxios
					.post(this.API_URL + `/Resources/GroupsPersonsEvaluations/SaveEvaluationPublic/${flagLanguage}`, this.evaluationData)
					.then(response => {
            
						if ( response.data != null && response.data.return ) {
     
              this.flag_resultados = true;
              this.evaluationData = response.data.entity;
              this.step = 3; 
              this.$forceUpdate();
     
						}else{
              console.log(response.data.message);
            }

            this.isLoading = false;
					})
          .catch(function (error) {
              console.log(error);
              this.isLoading = false;
          });

      }
    },
  },
 
};
</script>
<style>
.iti__flag {
    background-image: url("/images/flags.png");
}

.form-control-phone{ 
    border: 1px solid #b7b8bd;
    border-radius: 8px;
    padding: 5px 15px;
    font-size: 15px;
    height: 52px;
    border-radius: 12px;
    display: block;
    background-color: #fff;
    background-clip: padding-box;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    width: 500px;
}

.form-control-phone:focus {
  outline: none;
}

.iti--separate-dial-code .iti__selected-flag{
  background-color: rgba(0, 0, 0, 0.05);
  border-end-start-radius: 10px;
  border-start-start-radius: 10px;
}
</style>


